'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _theme = require('../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line local-rules/no-deep-relative-imports

/** @component */
var GlobalFontFace = function (_React$PureComponent) {
  (0, _inherits3.default)(GlobalFontFace, _React$PureComponent);

  function GlobalFontFace(props) {
    (0, _classCallCheck3.default)(this, GlobalFontFace);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalFontFace.__proto__ || Object.getPrototypeOf(GlobalFontFace)).call(this, props));

    if (props.theme && typeof window !== 'undefined') {
      _this.injectGlobalFontFace(props.theme);
      _this.applyToDom(props.theme);
    }
    return _this;
  }

  (0, _createClass3.default)(GlobalFontFace, [{
    key: 'injectGlobalFontFace',
    value: function injectGlobalFontFace(_ref) {
      var fontVariants = _ref.fontVariants;

      var fonts = [];

      if (typeof fontVariants === 'function') {
        fonts = fontVariants();
      } else if (Array.isArray(fontVariants)) {
        fonts = fontVariants;
      }

      fonts.forEach(function (variant) {
        // eslint-disable-next-line
        (0, _theme.injectGlobal)('@font-face{font-family:\'', variant.family, '\';src:url(\'', variant.url, '\') format(\'', variant.format, '\');font-weight:', variant.weight, ';}');
      });
    }
  }, {
    key: 'applyToDom',
    value: function applyToDom(theme) {
      if (!theme.font) {
        return;
      }

      // eslint-disable-next-line
      (0, _theme.injectGlobal)('body{font-family:', theme.font.body, ';font-weight:400;}');
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return GlobalFontFace;
}(_react2.default.PureComponent);

exports.default = (0, _theme.withTheme)(GlobalFontFace);